import React, { useState, useEffect } from "react";
import { Form, Select, InputNumber, Typography } from "antd";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { elvis } from "../../Utils";

const { Option } = Select;
const { Title } = Typography;

const LandForm = props => {
  const [form] = Form.useForm();
  const [functionTypes, setFunctionTypes] = useState([]);
  const [configurationTypes, setConfigurationTypes] = useState([]);
  const [soilTypes, setSoilTypes] = useState([]);
  const { t } = useTranslation();
  const isEditMode = props.isEditMode || false;

  const formItemLayout = {
    labelCol: {
      sm: { span: 8 }
    },
    wrapperCol: {
      sm: { span: 16 }
    }
  };

  // Load all types
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_ENDPOINT + "/farm/enums/land-functions")
      .then(({ data }) => {
        setFunctionTypes(data);
      })
      .catch(function (error) {
        console.log(error);
      });
    axios
      .get(process.env.REACT_APP_API_ENDPOINT + "/farm/enums/land-configurations")
      .then(({ data }) => {
        setConfigurationTypes(data);
      })
      .catch(function (error) {
        console.log(error);
      });
    axios
      .get(process.env.REACT_APP_API_ENDPOINT + "/farm/enums/land-soil-types")
      .then(({ data }) => {
        setSoilTypes(data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  // Initialize form with record data
  useEffect(() => {
    if (props.record.asset) {
      form.setFieldsValue({
        value: props.record.asset.value,
        landFunction: props.record.asset.landFunction,
        soil: props.record.asset.soil,
        configuration: props.record.asset.configuration,
        dimension: props.record.asset.dimension
      });
    }
  }, [props.record.asset, form]);

  // Reset form when exiting edit mode
  useEffect(() => {
    if (!isEditMode && props.record.asset) {
      form.resetFields();
      form.setFieldsValue({
        value: props.record.asset.value,
        landFunction: props.record.asset.landFunction,
        soil: props.record.asset.soil,
        configuration: props.record.asset.configuration,
        dimension: props.record.asset.dimension
      });
    }
  }, [isEditMode, form, props.record.asset]);

  // Handle form changes and notify parent
  const handleFormChange = () => {
    if (!isEditMode) return;

    const values = form.getFieldsValue();
    console.log("LandForm - Form values:", values);
    console.log("LandForm - After elvis:", {
      landFunction: elvis(values.landFunction),
      soil: elvis(values.soil),
      configuration: elvis(values.configuration)
    });
    const errors = form.getFieldsError();
    const isValid = errors.every(error => !error.errors.length);

    const newAsset = { ...props.record };
    newAsset.asset.value = elvis(values.value);
    newAsset.asset.landFunction = elvis(values.landFunction);
    newAsset.asset.soil = elvis(values.soil);
    newAsset.asset.configuration = elvis(values.configuration);
    newAsset.asset.dimension = elvis(values.dimension);
    newAsset.valid = isValid;

    console.log("LandForm - Sending to parent:", JSON.stringify(newAsset.asset));
    props.parentCallback(newAsset);
  };

  return (
    <Form
      form={form}
      {...formItemLayout}
      className="details_form"
      onValuesChange={handleFormChange}
      onFieldsChange={handleFormChange}
    >
      <Title
        className="details_form_header"
        title="Asset details"
        subTitle="Land"
      />

      <Form.Item
        label="Value (€)"
        name="value"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <InputNumber disabled={!isEditMode} />
      </Form.Item>

      <Form.Item
        label="Dimension (mq)"
        name="dimension"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <InputNumber disabled={!isEditMode} />
      </Form.Item>

      <Form.Item
        label="Function"
        name="landFunction"
        tooltip="Function of the land"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <Select disabled={!isEditMode}>
          {functionTypes.map(name => (
            <Option key={name} value={name}>
              {t("farmEnums.land_function." + name, name)}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="Soil type"
        name="soil"
        tooltip="Soil type of the land"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <Select disabled={!isEditMode}>
          {soilTypes.map(name => (
            <Option key={name} value={name}>
              {t("farmEnums.land_soil_type." + name, name)}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="Configuration"
        name="configuration"
        tooltip="Configuration of the land"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <Select disabled={!isEditMode}>
          {configurationTypes.map(name => (
            <Option key={name} value={name}>
              {t("farmEnums.land_configuration." + name, name)}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </Form>
  );
};

export default LandForm;